import React, { memo, useMemo } from 'react';
import { PageStatResponse } from '@business/entities/stats';
import { Row, Col, Card, CardBody, Media } from 'reactstrap';
import classNames from 'classnames';
import { WithTooltip } from '../WithTooltip';
import { R } from '@core/utils/r';
import './index.scss';
import { openPageStatsOverlay } from '../PageStatsOverlay';

export interface PageStatsProps {
  stats: PageStatResponse[];
}

export const PageStats = memo((props: PageStatsProps) => {
  const { stats } = props;
  return (
    <Row>
      {stats.map((stat, index) => (
        <PageStat key={index} stat={stat} />
      ))}
    </Row>
  );
});

const PageStat = memo((props: { stat: PageStatResponse }) => {
  const { stat } = props;

  return (
    <Col lg={stat.colWidth || 3}>
      <Card className="page-stat-details">
        <CardBody>
          <Media>
            <Media body>
              <p className="text-muted fw-medium">
                {stat.title}
                {!R.isEmpty(stat.description) && (
                  <WithTooltip tooltip={stat.description}>
                    <i className="ml-2 fa fa-info-circle"></i>
                  </WithTooltip>
                )}
                {!!stat.value.hasDetails && (
                  <span
                    className="ml-2"
                    style={{ cursor: 'pointer' }}
                    onClick={() => openPageStatsOverlay({ type: stat.value.detailsKey!, title: stat.title })}
                  >
                    <i className="mdi mdi-eye font-size-16 text-dark" style={{ marginTop: -4 }}></i>
                  </span>
                )}
              </p>

              <h4 className={classNames('mb-0', stat.value.className)}>{stat.value.value}</h4>
            </Media>
            {!!stat.icon && (
              <div className="avatar-xs rounded-circle bg-primary align-self-center mini-stat-icon">
                <span className="avatar-title rounded-circle bg-primary">
                  <i className={stat.icon.name + ' font-size-16 ' + stat.icon.iconClass}></i>
                </span>
              </div>
            )}
          </Media>
        </CardBody>
      </Card>
    </Col>
  );
});
